import * as React from 'react'
import { FC } from 'react'
import { ISalesFunnelSectionEditModel } from '@user/store/salesFunnel/typings'
import { SalesFunnelSection } from './SalesFunnelSection'

interface Props {
  sections: ISalesFunnelSectionEditModel[]
}

export const SalesFunnelSectionList: FC<Props> = (props) => {
  const { sections } = props

  return (
    <>
      {sections.map((section) => (
        <SalesFunnelSection key={section.id} section={section} />
      ))}
    </>
  )
}
